import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputText } from 'primeng/inputtext';
import { ActivityFormService } from 'src/app/trip-calculator/services/activity-form.service';
import { ErrorComponent } from '../../error/error.component';
import { ButtonModule } from 'primeng/button';
import { SelectActivityTypeComponent } from './select-activity-type/select-activity-type.component';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { DistanceFormComponent } from './distance-form/distance-form.component';
import { DurationFormComponent } from './duration-form/duration-form.component';
import { DurationDaysFormComponent } from './duration-days-form/duration-days-form.component';
import { PassengerFormComponent } from './passenger-form/passenger-form.component';
import { SelectCalculationModeComponent } from './select-calculation-mode/select-calculation-mode.component';
import { ScheduledDaysSelectorComponent } from '../../custom-input/scheduled-days-selector/scheduled-days-selector.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { SelectCustomFactorComponent } from '../../custom-input/select-custom-factor/select-custom-factor.component';
import { EmissionFactorCategory } from 'src/app/factors/types/factor';

@Component({
  selector: 'app-activity-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    InputText,
    ErrorComponent,
    ButtonModule,
    SelectActivityTypeComponent,
    DistanceFormComponent,
    DurationFormComponent,
    DurationDaysFormComponent,
    PassengerFormComponent,
    SelectCalculationModeComponent,
    ScheduledDaysSelectorComponent,
    SelectCustomFactorComponent,
  ],
  templateUrl: './activity-modal.component.html',
})
export class ActivityModalComponent {
  activityFormService = inject(ActivityFormService);
  prestationModalService = inject(PrestationModalService);
  tripService = inject(TripService);
  loading: boolean = false;
  factorCategory = EmissionFactorCategory.Activity;

  submit() {
    this.loading = true;
    this.activityFormService.submitActivity()?.subscribe({
      next: () => {
        this.loading = false;
        this.revalidateTrip();
        this.close();
      },
      error: () => (this.loading = false),
    });
  }

  /**
   * Trigger re-validation of the trip after successful save
   */
  private revalidateTrip() {
    const trip = this.tripService.trip();
    if (!trip?.id) return;

    this.tripService.triggerValidation(trip.id);
  }
  close() {
    this.prestationModalService.close();
    this.activityFormService.resetFormGroup();
  }
}
